import type { IconName } from './icon-names';

const req = require.context('./', false, /\.svg$/);
const icons = {} as Record<IconName, React.ComponentType<React.SVGProps<SVGSVGElement>>>;

req.keys().forEach((key: string) => {
  const iconName = key.replace('./', '').replace('.svg', '') as IconName;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  icons[iconName] = req(key).default || req(key);
});

// Re-export the generated IconName type for convenience
export type { IconName };

export default icons;
